export const categories = [
  {
    id: 'yimu-youhuo',
    slug: 'yimu-youhuo',
    name: '姨母的诱惑',
    description: '以「年长女性与年轻男性」为叙事核心的经典情感主题，探讨成熟女性魅力与社会禁忌之间的张力美学。',
    icon: 'ri-heart-pulse-line',
    count: 28,
  },
  {
    id: 'jinqing-qinggan',
    slug: 'jinqing-qinggan',
    name: '禁忌情感文学',
    description: '跨越道德边界的情感叙事，在禁忌中探寻人性的深邃与复杂，呈现欲望与理性的激烈碰撞。',
    icon: 'ri-fire-line',
    count: 35,
  },
  {
    id: 'chengshu-nvxing',
    slug: 'chengshu-nvxing',
    name: '成熟女性情感',
    description: '聚焦成熟女性的内心世界与情感历程，解读岁月赋予她们的独特魅力与智慧沉淀。',
    icon: 'ri-women-line',
    count: 22,
  },
  {
    id: 'qinggan-jiexi',
    slug: 'qinggan-jiexi',
    name: '情感故事解析',
    description: '深入剖析经典情感作品中的叙事技巧、人物塑造与情感张力，提升读者的文学鉴赏力。',
    icon: 'ri-book-open-line',
    count: 19,
  },
  {
    id: 'chuangzuo-jiqiao',
    slug: 'chuangzuo-jiqiao',
    name: '创作技巧分享',
    description: '为情感文学创作者提供实用的写作指导，从人物设计到情节铺设，全方位提升写作水平。',
    icon: 'ri-quill-pen-line',
    count: 16,
  },
  {
    id: 'renxing-wenxue',
    slug: 'renxing-wenxue',
    name: '人性情感文学',
    description: '以文学视角审视人性中最为隐秘的情感角落，在文字的张力中感受人性的复杂与真实。',
    icon: 'ri-psychotherapy-line',
    count: 24,
  },
];

export const articles = [
  {
    id: 1,
    title: '姨母的诱惑：成熟女性魅力的文学解构',
    excerpt: '在当代情感文学中，「姨母」这一角色承载着超越血缘的情感张力。本文从文学批评的角度，解析姨母形象背后的社会文化隐喻与人性深度。',
    content: `<p>在当代情感文学的创作版图中，「姨母」这一角色形象以其独特的情感张力和文化复杂性，成为近年来最受关注的人物原型之一。当我们谈论「姨母的诱惑」时，我们实际在探讨一种超越简单情欲叙事的深层情感结构。</p>
    
    <h3>一、姨母形象的文化基因</h3>
    <p>在中国传统文化语境中，「姨母」这一称谓天然携带着亲缘的温情和辈分的距离感。她是母亲家族中的女性长辈，既有母性的关怀本能，又不存在直接的母女冲突张力。这种特殊的社会关系位置，为文学创作提供了丰富的情感叙事空间。</p>
    <p>在当代都市语境下，姨母形象逐渐脱离了传统血缘关系的束缚，演变为一种更具普遍性的符号——代表着成熟、知性、富有生活阅历且保持魅力的年长女性。这种形象的文学价值在于，它打破了传统男性凝视下的女性刻板印象，为读者呈现了一个有血有肉、充满矛盾与复杂性的真实女性形象。</p>
    
    <h3>二、诱惑叙事的双重维度</h3>
    <p>「姨母的诱惑」之所以具备强大的文学感染力，在于它同时运作于两个维度：身体层面的吸引力与精神层面的引导力。年长女性的身体魅力往往被描绘为一种经过岁月打磨的成熟之美，不同于少女的青涩，而是一种带着故事感与沉淀感的独特韵味。</p>
    <p>然而更为重要的，是精神层面的「诱惑」。成熟女性往往拥有更为丰富的知识储备、更为成熟的世界观，以及更为细腻的情感表达能力。她们对年轻男性的吸引力，在很大程度上源自于这种精神层面的滋养与引领。</p>
    
    <h3>三、社会禁忌与人性张力</h3>
    <p>任何具有持久文学价值的叙事，都必然触及某种社会禁忌。姨母与年轻男性之间的情感关系，天然地触及了社会对正常恋爱关系的定义边界。然而，优秀的文学作品并非简单地挑战禁忌，而是通过禁忌这一叙事工具，深入探讨人性中那些被日常规范所遮蔽的复杂面向。</p>
    <p>在这种叙事框架下，禁忌成为了一面镜子，照映出角色内心深处的欲望、恐惧、羞耻与勇气。读者的阅读快感，正是来自于随同角色一起穿越这道道德迷雾，最终抵达人性理解的明亮地带。</p>
    
    <h3>四、经典作品推荐</h3>
    <p>在当代华语文学中，已经涌现出一批以成熟女性情感为核心的优秀作品。这些作品不仅在叙事技巧上日臻成熟，更在情感深度和人性探索方面达到了相当的高度。我们将在后续的文章中，逐一推荐和深入解析这些值得品味阅读的精品之作。</p>`,
    category: 'yimu-youhuo',
    categoryName: '姨母的诱惑',
    author: '林晚风',
    date: '2026-08-10',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20reading%20in%20a%20warm%20lit%20library%20with%20bookshelves%20and%20soft%20window%20light%2C%20literary%20atmosphere%2C%20sophisticated%20and%20refined%20mood%2C%20soft%20cream%20and%20burgundy%20tones%2C%20artistic%20photography%20style&width=800&height=500&seq=article-01&orientation=landscape',
    featured: true,
    tags: ['姨母文学', '情感分析', '文学批评'],
  },
  {
    id: 2,
    title: '禁断之爱：当伦理边界遇见真实情感',
    excerpt: '伦理与情感的冲突是文学永恒的母题。本文探讨禁忌情感文学如何通过伦理困境的设置，揭示人性中最真实、最不能自已的情感力量。',
    content: `<p>禁忌情感文学之所以能够跨越时代、穿透文化壁垒，在世界文学版图中占据核心位置，正是因为它在看似离经叛道的叙事表象下，承载着对人性最为坦诚也最为深刻的追问。</p>
    
    <h3>一、禁忌的双重面孔</h3>
    <p>禁忌在文学中的功能是双重的：它既是叙事张力的来源，也是社会批判的工具。当我们阅读一部涉及年龄差、身份差或血缘边缘的情感作品时，首先感受到的是禁忌带来的紧张感——「他们不应该在一起」这一认知本身，就为阅读注入了悬疑与刺激。</p>
    <p>但优秀的禁忌情感文学并不会停留在感官刺激的层面。它会引导读者穿越最初的猎奇心态，进入一个更为宏大的思考空间：为什么这样的关系会被禁止？禁忌背后隐含的社会规范是否合理？当个人的真实情感与社会规范发生冲突时，我们应当何去何从？</p>
    
    <h3>二、年龄差叙事的独特魅力</h3>
    <p>在禁忌情感文学的诸多类型中，年长女性与年轻男性之间的情感叙事具有独特的文学魅力。这种关系打破了传统性别权力结构——年长男性与年轻女性的配对在历史上司空见惯，而反向的年龄差则天然携带了颠覆性的力量。</p>
    <p>在这种叙事框架下，女性不再是欲望的客体，而是拥有主体性、经验与智慧的情感引导者。年轻男性则从传统叙事中的征服者位置，转变为被吸引、被滋养、被引领的一方。这种角色反转本身就具有强烈的文学张力和社会批判意味。</p>
    
    <h3>三、从世俗伦理到情感真实</h3>
    <p>所有伟大的禁忌情感作品，最终都会完成一个关键叙事动作：让读者从最初的道德评判者，转变为对角色处境的深切同情者。这种转变不是通过简单的说教完成的，而是通过细腻的人物刻画和情感铺陈，让读者意识到——在特定的人生境遇下，所谓的「道德」可能恰恰是对人性最大的不道德。</p>`,
    category: 'jinqing-qinggan',
    categoryName: '禁忌情感文学',
    author: '苏曼青',
    date: '2026-08-08',
    readTime: '15分钟',
    image: 'https://readdy.ai/api/search-image?query=Two%20silhouettes%20in%20a%20dimly%20lit%20room%20with%20warm%20amber%20lighting%2C%20emotional%20distance%20and%20tension%2C%20literary%20and%20cinematic%20atmosphere%2C%20soft%20focus%20and%20elegant%20composition%2C%20deep%20burgundy%20and%20cream%20tones&width=800&height=500&seq=article-02&orientation=landscape',
    featured: true,
    tags: ['禁忌情感', '伦理探讨', '人性分析'],
  },
  {
    id: 3,
    title: '岁月沉香：成熟女性的文学肖像',
    excerpt: '从张爱玲到王安忆，再到当代网络文学中的成熟女性形象——本文梳理华语文学中成熟女性形象的流变，探讨「岁月」如何在女性身上留下独特的魅力印记。',
    content: `<p>在华语文学的长河中，成熟女性形象的塑造经历了从边缘到中心、从刻板到丰盈的漫长演变。时至今日，当我们重新审视这一人物谱系时，会发现一幅远比想象更加丰富和动人的文学图景。</p>
    
    <h3>一、传统书写中的成熟女性</h3>
    <p>在传统文学中，成熟女性常常被简化为两种极端形象：要么是失去性魅力的「老妇」，要么是危险而迷人的「妖妇」。这两种形象虽然表面上截然不同，但都源自于男性中心视角对女性年龄的焦虑和幻想。</p>
    <p>张爱玲的出现打破了这一困局。她笔下的成熟女性——无论是《金锁记》中的曹七巧，还是《倾城之恋》中的白流苏——都具有惊人的心理深度和复杂性。她们不再是简单的符号，而是拥有完整内心世界的真实人物。</p>
    
    <h3>二、当代叙事的多元突破</h3>
    <p>进入当代，随着女性作家群体的崛起和网络文学平台的壮大，成熟女性形象获得了前所未有的表现空间。在这些作品中，成熟女性不再是被书写的对象，而逐渐成为叙事的主体——她们拥有自己的欲望、追求和故事。</p>
    <p>特别值得关注的是，近年来涌现出的一批以「姨母」或「姐姐」为核心的情感叙事作品。这些作品大胆地触及年龄差情感、成熟女性的性魅力等传统禁区，以一种前所未有的坦率态度，呈现了成熟女性的情感世界。</p>
    
    <h3>三、岁月赋予的独特魅力</h3>
    <p>在文学表达中，成熟女性的魅力从来不是岁月的减法，而是加法。那些被时光打磨过的眼角细纹、历经风雨后沉淀的从容气度、在人生阅历中淬炼出的智慧光芒——这些都不是年轻可以替代的美学品质。</p>
    <p>优秀的文学作品，正是通过细腻的文字描摹，让读者感受到这种「沉香」般的美——不是张扬的、一览无余的美，而是需要细细品味、在时间的流逝中慢慢释放的深邃之美。</p>`,
    category: 'chengshu-nvxing',
    categoryName: '成熟女性情感',
    author: '江月明',
    date: '2026-08-05',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20in%20a%20classic%20Chinese%20qipao%20sitting%20by%20a%20window%20with%20afternoon%20light%2C%20literary%20and%20nostalgic%20atmosphere%2C%20warm%20cream%20and%20soft%20rose%20tones%2C%20artistic%20photography&width=800&height=500&seq=article-03&orientation=landscape',
    featured: false,
    tags: ['女性形象', '文学史', '角色分析'],
  },
  {
    id: 4,
    title: '情感小说的叙事密码：如何写出令人心颤的张力',
    excerpt: '优秀的情感小说有着共同的叙事密码。本文从结构、节奏、对白、留白四个维度，拆解情感小说中「张力」的构建技巧。',
    content: `<p>在情感小说的创作中，「张力」是衡量作品质量的核心指标之一。一部能让读者心跳加速、手心出汗的情感作品，必然在叙事张力的构建上有着精妙的设计。本文将从四个维度，系统地解析情感张力的构建技巧。</p>
    
    <h3>一、结构张力：期待与延迟的艺术</h3>
    <p>情感小说中最基本的张力来源于读者的期待与叙事者的延迟之间的博弈。当读者意识到两个角色之间存在情感可能时，张力就已经产生。高明的作家会巧妙地调控「信息释放」的节奏——让读者不断逼近答案，又不断被新的障碍阻隔。</p>
    <p>这种结构张力的经典模式包括：误解式延迟（角色因误会而错过）、命运式延迟（外部事件打断关键时刻）、以及心理式延迟（角色自身的心结成为阻碍）。三种模式可以单独使用，更可以组合运用，形成复调式的张力结构。</p>
    
    <h3>二、对白张力：言说与沉默之间</h3>
    <p>在情感叙事中，对白的张力往往不是来自于「说了什么」，而是「没说什么」。角色的欲言又止、言不由衷、词不达意——这些语言表达的「缝隙」，恰恰是情感张力最为密集的场域。</p>
    <p>优秀的对白写作要求作者同时处理三个层次：字面意义（角色说的什么）、情感意义（角色想说的什么）、以及关系意义（这句话如何影响两个角色的关系）。三个层次之间的落差越大，对白的张力就越强。</p>
    
    <h3>三、节奏张力：快慢之间的心跳</h3>
    <p>情感小说的叙事节奏如同音乐，需要张弛有度的把控。在关键的情感爆发点之前，需要足够的铺垫和积累；而在爆发之后，则需要适当的留白让读者消化和回味。</p>
    <p>一个实用的节奏设计技巧是「三幕递增」：将情感发展的关键场景分为三个层次，每个层次的情感强度递增，给读者一种不断攀升的阅读体验。</p>`,
    category: 'chuangzuo-jiqiao',
    categoryName: '创作技巧分享',
    author: '陈墨白',
    date: '2026-08-03',
    readTime: '13分钟',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20typewriter%20and%20scattered%20manuscripts%20on%20a%20warm%20wooden%20desk%20with%20a%20cup%20of%20tea%2C%20soft%20window%20light%2C%20literary%20creative%20atmosphere%2C%20warm%20amber%20and%20cream%20tones&width=800&height=500&seq=article-04&orientation=landscape',
    featured: false,
    tags: ['写作技巧', '叙事结构', '创作指南'],
  },
  {
    id: 5,
    title: '《半生》深度解析：一部姨母叙事的经典之作',
    excerpt: '网络作者「沉璧」的代表作《半生》，以其细腻入微的笔触和对姨母形象的深刻塑造，成为近年情感文学领域的现象级作品。本文对其进行全面解析。',
    content: `<p>如果要在近五年的华语情感文学中评选一部最具代表性的「姨母叙事」作品，沉璧的《半生》无疑会高居榜首。这部作品以其近百万字的篇幅，细致入微地呈现了一段跨越年龄、身份和世俗偏见的情感历程。</p>
    
    <h3>一、人物塑造：超越刻板的真实感</h3>
    <p>《半生》最令人称道的成就，在于对女主角苏婉清这一「姨母」形象的塑造。沉璧没有将她写成一个完美无瑕的理想化形象，恰恰相反，苏婉清身上有着丰富而真实的缺陷——她的犹豫、她的自私、她在道德与欲望之间的摇摆，都被作者以细腻的笔触毫无保留地呈现出来。</p>
    <p>正是这种不完美，让苏婉清成为了一个有血有肉的真实人物。读者能够在她身上看到自己或身边人的影子，从而产生深切的共情。这种真实感，是《半生》能够打动如此多读者的根本原因。</p>
    
    <h3>二、叙事结构：双线交织的情感层次</h3>
    <p>《半生》采用了现在与过去双线交织的叙事结构。一方面，读者跟随男主角程远的视角，见证他与苏婉清从相识到相知的全过程；另一方面，苏婉清的过往——她的婚姻、她的创伤、她的成长——通过闪回段落徐徐展开。</p>
    <p>这种双线结构的美妙之处在于，它让读者对女主角的理解始终处于动态调整之中。每一次闪回，都是对前文的一次重新诠释，让读者的情感判断不断被挑战和重塑。</p>
    
    <h3>三、语言风格：沉静内敛的叙事美学</h3>
    <p>沉璧的文字具有一种沉静内敛的气质。她很少使用华丽的修辞或激烈的语调，而是以一种近乎白描的笔法，平静地呈现人物最激烈的情感波动。这种「冷笔写热事」的风格，创造出一种独特的审美张力——文字的克制与人物的炽烈形成强烈反差。</p>`,
    category: 'qinggan-jiexi',
    categoryName: '情感故事解析',
    author: '周暮烟',
    date: '2026-07-28',
    readTime: '14分钟',
    image: 'https://readdy.ai/api/search-image?query=An%20open%20book%20on%20a%20reading%20table%20with%20warm%20lamp%20light%20and%20a%20cup%20of%20coffee%2C%20cozy%20reading%20nook%20with%20bookshelves%2C%20literary%20atmosphere%2C%20soft%20cream%20and%20burgundy%20tones&width=800&height=500&seq=article-05&orientation=landscape',
    featured: true,
    tags: ['作品解析', '《半生》', '沉璧'],
  },
  {
    id: 6,
    title: '人性暗涌：情感文学中的欲望书写与道德反思',
    excerpt: '欲望是情感文学的核心动力。本文探讨如何在不落入低俗的前提下，用文字呈现人性欲望的复杂面貌，并引发读者的道德反思。',
    content: `<p>在情感文学，尤其是涉及禁忌题材的情感文学中，「欲望书写」一直是一个敏感而关键的话题。如何在呈现人性欲望的同时避免沦为低俗刺激，是每一位严肃写作者必须直面的创作伦理问题。</p>
    
    <h3>一、欲望书写的文学传统</h3>
    <p>事实上，欲望书写在世界文学中拥有悠久而辉煌的传统。从《金瓶梅》到《查泰莱夫人的情人》，从渡边淳一到米兰·昆德拉——严肃文学从未回避对人性的欲望层面进行深入描摹。</p>
    <p>关键在于写作的态度和方法。当欲望书写服务于人物塑造和主题表达时，它就是文学；当它仅仅服务于感官刺激时，它就滑向了低俗。二者的界限虽然微妙，但并非不可辨识。</p>
    
    <h3>二、含蓄美学与留白技巧</h3>
    <p>华语文学在欲望书写方面有着独特的「含蓄美学」传统。通过隐喻、暗示、留白等技巧，作家可以在不完全呈现细节的前提下，让读者感受到欲望的强大力量。这种「不言而喻」的写法，往往比直白的描写更具文学感染力和想象力空间。</p>
    
    <h3>三、道德反思的叙事功能</h3>
    <p>优秀的欲望书写从来不是单纯地「展示」欲望，而是在展示的同时引发读者的道德反思。当读者跟随角色的欲望之旅走到终点，回望来路，那些曾经让人面红耳热的场景，会在新的理解高度上获得不同的意义。</p>`,
    category: 'renxing-wenxue',
    categoryName: '人性情感文学',
    author: '顾清溪',
    date: '2026-07-25',
    readTime: '11分钟',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20art%20of%20two%20figures%20in%20emotional%20tension%2C%20warm%20and%20dark%20color%20palette%2C%20artistic%20and%20literary%20atmosphere%2C%20soft%20brushstroke%20texture%2C%20deep%20rose%20and%20charcoal%20tones&width=800&height=500&seq=article-06&orientation=landscape',
    featured: false,
    tags: ['欲望书写', '道德反思', '文学伦理'],
  },
  {
    id: 7,
    title: '禁忌之美的文学溯源：从古希腊到当代华语文学',
    excerpt: '禁忌叙事并非当代文学的发明。本文追溯禁忌情感在东西方文学中的发展脉络，揭示这一文学母题跨越千年的生命力。',
    content: `<p>禁忌情感作为文学母题，其历史几乎与文学本身一样古老。从古希腊悲剧到当代网络小说，禁忌的叙事魅力跨越了时间和空间的界限，持续地吸引着一代又一代的读者和创作者。</p>
    
    <h3>一、古希腊悲剧中的禁忌原型</h3>
    <p>在西方文学传统中，禁忌叙事的最经典原型无疑是索福克勒斯的《俄狄浦斯王》。这部悲剧所触及的母子关系禁忌，在此后的两千多年中持续发酵，成为弗洛伊德精神分析理论的核心概念，也深刻影响了无数文学作品的创作。</p>
    <p>值得注意的是，古希腊人在处理这一禁忌主题时展现出的并非简单的道德谴责，而是一种更为复杂的态度——他们承认命运的力量，同时对人类的悲剧处境寄予深切的同情。</p>
    
    <h3>二、东方文学中的禁忌传统</h3>
    <p>在华语文学传统中，禁忌情感同样有着悠久的表达历史。从《红楼梦》中贾宝玉与秦可卿之间的微妙情愫，到《金瓶梅》中对欲望的大胆呈现——东方文学在处理禁忌主题时，往往更注重「含蓄」和「留白」的美学。</p>
    <p>这种含蓄美学并非出于胆怯，而是一种更高明的叙事策略——通过不说出来的部分，激发读者更丰富的想象力和更深的思考。</p>
    
    <h3>三、当代华语文学中的禁忌叙事</h3>
    <p>进入21世纪，随着网络文学的兴起，禁忌情感叙事获得了前所未有的表达空间。大量以姨母、姐姐等成熟女性为核心的网络文学作品涌现，形成了独具特色的「姨母文学」亚类型。这些作品在继承传统含蓄美学的基础上，融入了更为当代的情感观念和叙事技巧。</p>`,
    category: 'jinqing-qinggan',
    categoryName: '禁忌情感文学',
    author: '林晚风',
    date: '2026-07-22',
    readTime: '16分钟',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Greek%20statue%20and%20Chinese%20classical%20scroll%20side%20by%20side%20in%20a%20museum%20setting%2C%20dramatic%20lighting%2C%20cultural%20fusion%2C%20academic%20and%20literary%20atmosphere%2C%20warm%20cream%20and%20stone%20tones&width=800&height=500&seq=article-07&orientation=landscape',
    featured: false,
    tags: ['文学溯源', '比较文学', '禁忌母题'],
  },
  {
    id: 8,
    title: '从阅读到创作：如何写好自己的第一部情感小说',
    excerpt: '许多情感文学的读者最终都萌生了创作的念头。本文为初涉创作的读者提供一套系统的入门指南，帮助你迈出创作的第一步。',
    content: `<p>在情感文学的读者群体中，有相当一部分人心中都藏着一个小小的创作梦想。如果你正是其中的一员，这篇文章就是为你准备的——一份真诚的、实用的、不求速成的创作入门指南。</p>
    
    <h3>一、从「我要写什么」开始</h3>
    <p>许多创作者的第一步就卡在了选题上。他们脑海中有着模糊的灵感和涌动的情感，却不知道如何将其落地为一个具体的创作计划。我的建议是：从一个你最熟悉、最能有感而发的情感体验入手。</p>
    <p>不需要宏大，不需要新奇。一段让你心动的回忆、一个让你久久不能忘怀的场景、一种你反复咀嚼的情感——这些都是绝佳的创作起点。文学的力量从来不在于题材的猎奇，而在于情感的真切。</p>
    
    <h3>二、人物是情感小说的灵魂</h3>
    <p>在情感小说中，人物塑造的重要性怎么强调都不为过。一个让读者记住的情感故事，背后一定有一个让读者牵挂的人物。塑造人物时，请务必赋予TA三个维度：外在特征（读者可以「看见」TA）、行为模式（读者可以「预判」TA）、以及内在动机（读者可以「理解」TA）。</p>
    
    <h3>三、完成比完美更重要</h3>
    <p>对于初涉创作的写作者来说，最大的障碍往往不是能力不足，而是「完美主义拖延」。请记住：你的第一稿不需要写得有多好，它只需要「被写完」。完成一部作品本身，就已经是一种巨大的成就和学习。修改和打磨，那是在完成之后才需要操心的事情。</p>`,
    category: 'chuangzuo-jiqiao',
    categoryName: '创作技巧分享',
    author: '陈墨白',
    date: '2026-07-18',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=A%20notebook%20and%20pen%20on%20a%20cozy%20desk%20with%20warm%20morning%20light%20streaming%20through%20a%20window%2C%20inspirational%20creative%20atmosphere%2C%20soft%20cream%20and%20warm%20amber%20tones&width=800&height=500&seq=article-08&orientation=landscape',
    featured: false,
    tags: ['创作入门', '写作指南', '新人必读'],
  },
  {
    id: 9,
    title: '情感文学中的「年龄差」美学：理论与作品分析',
    excerpt: '年龄差是情感文学中最富张力的叙事元素之一。本文将系统分析不同年龄差模式的美学特征与叙事可能，为读者和创作者提供参考。',
    content: `<p>在情感文学的各种叙事元素中，「年龄差」无疑是制造张力的高效工具之一。年龄差异带来的权力不对等、经验鸿沟、社会偏见以及代际文化差异，为叙事提供了丰富的冲突来源和情感维度。</p>
    
    <h3>一、年龄差的情感动力学</h3>
    <p>当一段情感关系中存在显著的年龄差异时，关系的动力学就会发生微妙而深刻的变化。年长一方往往在经验、资源和情感成熟度上占据优势，这种优势既是吸引力的来源，也是关系不平衡的隐患。</p>
    <p>在「姨母叙事」中，年龄差异通常呈现为年长女性与年轻男性的配对。这种配对的有趣之处在于，它同时颠覆了两种传统权力结构：性别权力（男性不再天然占据主导）和年龄权力（年长者虽然经验丰富，但女性身份的弱势部分抵消了年龄的优势）。</p>
    
    <h3>二、不同年龄差的美学特征</h3>
    <p>5-8岁的年龄差：这是最为温和的年龄差模式，情感张力主要来源于生活阶段的错位而非根本性的代际隔阂。作品往往聚焦于「时机」的主题——对的人，错的时间。</p>
    <p>10-15岁的年龄差：这是「姨母叙事」最为经典的年龄差区间。社会偏见开始变得显著，角色需要面对的不仅是内心的情感，还有外界的眼光。作品的主题往往围绕「勇气」与「社会规范」的博弈展开。</p>`,
    category: 'yimu-youhuo',
    categoryName: '姨母的诱惑',
    author: '江月明',
    date: '2026-07-14',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Two%20people%20of%20different%20ages%20sitting%20at%20a%20cafe%20window%2C%20emotional%20connection%20visible%20in%20their%20expressions%2C%20warm%20afternoon%20light%2C%20literary%20cinematic%20atmosphere%2C%20soft%20burgundy%20and%20cream%20tones&width=800&height=500&seq=article-09&orientation=landscape',
    featured: true,
    tags: ['年龄差', '美学分析', '叙事理论'],
  },
];

export const testimonials = [
  {
    id: 1,
    name: '清韵',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Chinese%20woman%20with%20elegant%20and%20literary%20look%2C%20soft%20lighting%2C%20warm%20tones%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    role: '资深读者',
    content: '这个网站让我重新认识了情感文学的价值。每一篇文章都写得很有深度，不是那种肤浅的猎奇，而是真正在探讨人性和情感。推荐给了好几个朋友，大家都很喜欢。',
    rating: 5,
  },
  {
    id: 2,
    name: '远山',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Chinese%20man%20with%20intellectual%20and%20thoughtful%20expression%2C%20soft%20lighting%2C%20warm%20tones%2C%20professional%20headshot%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    role: '情感文学创作者',
    content: '作为一个正在尝试写情感小说的新人，这里的创作技巧文章给了我很多启发。特别是关于叙事结构和人物塑造的文章，让我对写作有了全新的理解。',
    rating: 5,
  },
  {
    id: 3,
    name: '若溪',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Chinese%20woman%20with%20warm%20and%20gentle%20smile%2C%20soft%20lighting%2C%20warm%20tones%2C%20natural%20headshot%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    role: '文学爱好者',
    content: '文章质量很高，每一篇都能感受到作者的用心。特别喜欢《半生》那篇解析，看完之后我立刻去找了原书来读，果然没有让人失望。',
    rating: 4,
  },
  {
    id: 4,
    name: '墨言',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20Chinese%20man%20with%20artistic%20and%20literary%20vibe%2C%20soft%20lighting%2C%20warm%20tones%2C%20creative%20headshot%20style&width=100&height=100&seq=avatar-04&orientation=squarish',
    role: '文学评论人',
    content: '在众多情感文学推荐平台中，这个网站的审美和深度都出类拔萃。它不仅推荐作品，更在帮助读者建立一套理解和欣赏情感文学的框架。',
    rating: 5,
  },
];

export const featuredBooks = [
  {
    id: 'b1',
    title: '《半生》',
    author: '沉璧',
    description: '当代姨母叙事的巅峰之作，以百万字篇幅细腻描绘一段跨越身份与世俗的情感历程。女主角苏婉清被评论界誉为近年来最具深度和真实感的成熟女性形象。',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20book%20cover%20design%20with%20soft%20warm%20tones%2C%20literary%20fiction%20aesthetic%2C%20Chinese%20style%20minimal%20design%2C%20cream%20and%20burgundy%20color%20palette%2C%20sophisticated%20typography&width=300&height=420&seq=book-01&orientation=portrait',
    rating: 4.8,
  },
  {
    id: 'b2',
    title: '《沉香如屑》',
    author: '苏眠',
    description: '以文物修复为背景的情感力作，女主角是年过四十的古画修复师，在与年轻学徒的相处中，一段微妙而动人的情感悄然生长。',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20book%20cover%20with%20ink%20wash%20style%2C%20literary%20Chinese%20fiction%2C%20warm%20and%20subdued%20color%20palette%2C%20sophisticated%20design%20with%20subtle%20texture&width=300&height=420&seq=book-02&orientation=portrait',
    rating: 4.6,
  },
  {
    id: 'b3',
    title: '《晚来的风》',
    author: '林晚风',
    description: '这是一部关于中年女性自我觉醒的长篇小说。女主角在四十岁那年，遇到了一个让她重新审视人生的年轻人，由此展开了一段关于自由、欲望与自我救赎的故事。',
    cover: 'https://readdy.ai/api/search-image?query=Artistic%20book%20cover%20with%20abstract%20floral%20elements%2C%20elegant%20literary%20design%2C%20warm%20cream%20and%20dusty%20rose%20colors%2C%20sophisticated%20Chinese%20contemporary%20fiction%20aesthetic&width=300&height=420&seq=book-03&orientation=portrait',
    rating: 4.5,
  },
  {
    id: 'b4',
    title: '《暗香》',
    author: '简安',
    description: '获得年度情感文学大奖的作品，讲述了一位成熟的姨母与年轻侄子的朋友之间发生的不期而遇的情感故事。文笔细腻，情感真挚。',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20elegant%20book%20cover%20with%20subtle%20shadow%20and%20light%20play%2C%20literary%20fiction%2C%20warm%20amber%20and%20cream%20tones%2C%20sophisticated%20design%2C%20Chinese%20contemporary%20literature&width=300&height=420&seq=book-04&orientation=portrait',
    rating: 4.7,
  },
  {
    id: 'b5',
    title: '《浮生若梦》',
    author: '白落梅',
    description: '经典再版的情感文学佳作，以诗意笔触描绘了一段跨越十五岁年龄差的深刻情感。被誉为当代华语情感文学的一座里程碑。',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20vintage%20style%20book%20cover%20with%20subtle%20gold%20details%2C%20classic%20Chinese%20literature%20aesthetic%2C%20warm%20cream%20and%20soft%20rose%20tones%2C%20timeless%20design&width=300&height=420&seq=book-05&orientation=portrait',
    rating: 4.9,
  },
];

export const heroSlides = [
  {
    id: 1,
    title: '探索姨母叙事中的情感密码',
    subtitle: '以文学之眼，洞见人性深处的光与影',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20reading%20room%20with%20warm%20lighting%20and%20bookshelves%2C%20soft%20burgundy%20and%20cream%20color%20palette%2C%20sophisticated%20literary%20atmosphere%2C%20cozy%20and%20refined%20interior%2C%20diffused%20natural%20light%20from%20window&width=1600&height=700&seq=hero-01&orientation=landscape',
    cta: '浏览精选文章',
    link: '/category/yimu-youhuo',
  },
  {
    id: 2,
    title: '岁月不语，文字有香',
    subtitle: '精品情感小说推荐，为品味读者甄选每一个值得阅读的故事',
    image: 'https://readdy.ai/api/search-image?query=An%20elegant%20woman%20silhouette%20reading%20by%20a%20large%20window%20with%20flowing%20curtains%2C%20warm%20afternoon%20light%2C%20sophisticated%20and%20serene%20atmosphere%2C%20literary%20mood%2C%20cream%20and%20soft%20amber%20tones&width=1600&height=700&seq=hero-02&orientation=landscape',
    cta: '发现更多好书',
    link: '/category/qinggan-jiexi',
  },
  {
    id: 3,
    title: '从阅读到创作：你的文学旅程',
    subtitle: '系统化的创作指南，帮助每一个有故事的人找到自己的声音',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20writing%20desk%20with%20manuscripts%20and%20a%20classic%20fountain%20pen%2C%20warm%20lamp%20light%2C%20literary%20creative%20space%2C%20sophisticated%20and%20inspiring%20atmosphere%2C%20cream%20and%20deep%20burgundy%20tones&width=1600&height=700&seq=hero-03&orientation=landscape',
    cta: '学习创作技巧',
    link: '/category/chuangzuo-jiqiao',
  },
];